"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  root: {
    backgroundColor: 'rgba(250, 250, 250, 0.84)'
  }
};